"use client";

import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Badge } from "@/components/ui/badge";

const CompanyTypeBadge: React.FC = () => {
  const { company, getFeatureAccess } = useAuth();

  const isConsulting = getFeatureAccess("ibp_consulting");
  const label = isConsulting ? "IBP Consulting" : "SaaS";
  const variant = isConsulting ? "default" : "secondary";

  if (!company) return null;

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm text-muted-foreground">Company Type:</span>
      <Badge variant={variant}>{label}</Badge>
    </div>
  );
};

export default CompanyTypeBadge;